import { useState } from "react";
import { columns, tableDataFixed } from "./testy/danedowyliczen";
import Harmonogram from "./harmonogram";
import { SortTest } from "./testy/danedowyliczen";


function Table () {

  let loanPeriod = 10;
  let balance = 5000;
  let interestRate = 8;
  let paymentRate = 1000;
  const tablica = [...Array(loanPeriod)]
  
  tablica.map((e,i) => {
    const interest = ((balance * interestRate) / 1200);
    const principal = (paymentRate - interest);

    balance = (balance - principal);
    console.log({i,balance, principal})
    return (
  
      <li key={i}>
        {i + 1}
        {balance}</li>  
    );
  })}

export default Table